// extracted by mini-css-extract-plugin
export default {"container":"MainWrapper_container__GCQZv"};